document.addEventListener("DOMContentLoaded", function () {
  const button = document.getElementById("create-draft-order");

  if (!button) return;

  const btnText = button.querySelector(".btn-text");
  const loaderText = button.querySelector(".loader-text");

  button.addEventListener("click", async function () {
    const payload = button.dataset.cartItems;

    let items;
    try {
      items = JSON.parse(payload);
    } catch (e) {
      alert("Error parsing cart data");
      return;
    }

    // Show loader, hide button text
    button.disabled = true;
    if (btnText) btnText.style.display = "none";
    if (loaderText) loaderText.style.display = "inline";

    try {
      const response = await fetch("https://backoffice.brightdigital.co/api/create-draft-order.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ items })
      });

      const result = await response.json();

      if (result.success && result.invoice_url) {
        setTimeout(() => {
          window.location.href = result.invoice_url;

          // Restore button state **after** delay
          button.disabled = false;
          if (btnText) btnText.style.display = "inline";
          if (loaderText) loaderText.style.display = "none";
        }, 3000);
      } else {
        alert("Failed to create draft order. Please try again.");
        console.error(result);

        // Restore state only on failure
        button.disabled = false;
        if (btnText) btnText.style.display = "inline";
        if (loaderText) loaderText.style.display = "none";
      }
    } catch (error) {
      console.error("API error", error);
      alert("An unexpected error occurred.");

      // Restore state on error
      button.disabled = false;
      if (btnText) btnText.style.display = "inline";
      if (loaderText) loaderText.style.display = "none";
    }
  });
});
